module.exports = __webpack_public_path__ + "img/WorldWhiteIcon.580cce43.svg";